<div class="mx-8 my-20" animate.enter="ease-in-fast" *transloco="let t">
  <div class="flex items-center justify-between">
    <div>
      <h1 class="text-3xl font-semibold">
        {{ t('portal.courseLibrary.courseLibraryHeadline') }}
      </h1>
      <h1 class="text-base text-grey">
        {{ t('portal.courseLibrary.subtitle') }}
      </h1>
    </div>

    <div class="flex gap-x-2">
      <app-input-field
        [control]="search"
        [placeholder]="t('general.search')"
        [icon]="'search'"
      />
      @if (topicAreas.length > 1 && !isLoadingTopicAreas) {
        <app-select
          [control]="topicAreaControl"
          [translocoPrefix]="'portal.courseLibrary.filterOptions'"
          [options]="topicAreas"
          [bottomMargin]="false"
          class="h-fit min-w-[260px]"
        />
      }
    </div>
  </div>

  @if (isLoadingCourses) {
    <div class="mt-10 flex justify-center">
      <div class="flex h-8 justify-center">
        <app-loading></app-loading>
      </div>
    </div>
  } @else {
    @if (recommended.length > 0) {
      <app-divider-with-text
        [text]="t('portal.courseLibrary.popularIntroductoryCourses')"
      />

      <div
        class="mt-10 grid max-w-[1400px] auto-rows-fr grid-cols-[repeat(auto-fill,332px)] justify-start gap-x-6 gap-y-12"
      >
        @for (course of filteredCourses; track course.id) {
          @if (course.isRecommended) {
            <app-course-library-card
              [course]="course"
              [isRecommended]="true"
              (courseCardClickEvent)="onOpenCourseCard(course)"
            />
          }
        }
      </div>
    }

    @if (filteredCourses.length > 0) {
      <app-divider-with-text [text]="t('portal.courseLibrary.allCourses')" />

      <div
        class="mt-10 grid max-w-[1400px] auto-rows-fr grid-cols-[repeat(auto-fill,332px)] justify-start gap-x-6 gap-y-12"
      >
        @for (course of filteredCourses; track course.id) {
          <app-course-library-card
            [course]="course"
            [isRecommended]="false"
            (courseCardClickEvent)="onOpenCourseCard(course)"
          />
        }
      </div>
    }

    @if (filteredCourses.length === 0) {
      <div class="mt-10 text-center text-lg text-grey">
        {{ t('portal.courseLibrary.noCoursesFound') }}
      </div>
    }
  }
</div>
